import { SimpleGrid } from "@chakra-ui/react";

export default function SimpleGridComponent({...props}){
    return <SimpleGrid 
        spacingY={{base:"5px",md:"10px"}}
        spacingX={"15px"}
        columns={{base:1,md:2,lg:3}}
    {...props}/>
}